import { orchestrator } from 'satcheljs';
import { createEmail } from '../actions/createEmail';
import { traceCreateEmailButtonClick } from '../utils/domainOptionTracer';
import { hideFullOptions } from 'owa-options-core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { PremiumDomainConnectSecondStep } from 'owa-domain-connect';
import store from '../store/store';
import SubscriberType from '../contracts/subscriberType';

export default orchestrator(createEmail, async function createEmail() {
    traceCreateEmailButtonClick();
    hideFullOptions();
    mountDomainConnectSecondStep();
});

function mountDomainConnectSecondStep() {
    var dcSecondStepContainer = document.createElement('div');
    document.body.appendChild(dcSecondStepContainer);
    ReactDOM.render(
        <PremiumDomainConnectSecondStep
            domainName={store.domainState.domainName}
            csrfToken={null}
            mountFromDomainDashBoard={true}
            isSecondaryUser={store.subscriberType == SubscriberType.Secondary}
            onClose={() => document.body.removeChild(dcSecondStepContainer)}
        />,
        dcSecondStepContainer
    );
}
